class Header4i {
    constructor() {
        this.userLinksWrapper = document.getElementById("userSpecificLinksBox");
        this.searchPromise = null;
        this.menuPromise = null;
        this.cartPromise = null;
        this.accountPromise = null;
        this.seoPromise = null;
    }

    init = () => {
        document.querySelector(".skip")?.removeAttribute("style");
        this.handleMobileChanges();
        this.makeSticky();
        this.loadUserLinks();

        window.addEventListener("resize", this.handleMobileChanges);
        if (window.innerHeight > 500) {
            window.addEventListener("scroll", this.makeSticky);
        }

        document.addEventListener("click", this.headerEvents);
    };

    headerEvents = async (e) => {
        const { target } = e;

        const actionsID = {
            txtSearch: async (e) => {
                e.preventDefault();
                const search = await this.loadSearch();
                if(search) search.handleFocusIn(e);
            },
            hdrAccountBtn: async (e) => {
                e.preventDefault();
                const account = await this.loadAccountDropdown();
                if(account) account.toggle();
            },
            hdrCartBtn: async (e) => {
                e.preventDefault();
                const cart = await this.loadCartDropdown();
                if(cart) cart.toggle();
            },
            callBtn: async (e) => {
                e.preventDefault();
                await this.logClickToCall();
                window.location.href = e.target.href;
            },
            seoBtn: async (e) => {
                e.preventDefault();
                const seo = await this.loadSEOEditor();
                if(seo) seo.toggle();
            },
            searchOpenSmall: async (e) => {
                e.preventDefault();
                const search = await this.loadSearch();
                if(search) search.handleMobileSearchClick(e);
            },
            submitSearch: async (e) => {
                e.preventDefault();
                const search = await this.loadSearch();
                if(search) search.handleSearchClick(e);
            },
            menuTrigger: async (e) => {
                e.preventDefault();
                const menu = await this.loadMenu();
                if(menu) menu.toggle();
            },
        };
    
        if (actionsID[target.id]) {
            actionsID[target.id](e);
        }
    };

    handleMobileChanges = () => {
        const headerLogo = document.querySelector(".headerLogo")?.parentNode;
        const menuBtn = document.querySelector(".headerMenuBtn");
        const isMobile = window.innerWidth < 600;
        const hasFlexClass = headerLogo.classList.contains("flexAlignItemsCenter");

        if (isMobile && !hasFlexClass) {
            headerLogo.classList.add("flexAlignItemsCenter");
            menuBtn.after(headerLogo);
        } else if (!isMobile && hasFlexClass) {
            headerLogo.classList.remove("flexAlignItemsCenter");
            headerLogo.after(menuBtn);
        }

        menuBtn.classList.remove("invisible");
        headerLogo.classList.remove("invisible");
    };

    makeSticky = () => {
        const topMenuBar = document.querySelector(".mainNavPlaceholder");
        const stickyHead = document.querySelector(".headerUserLinksPlaceholder");

        if(!stickyHead || !topMenuBar){ return; }

        if(window.scrollY > topMenuBar.offsetHeight){
            if(!stickyHead.classList.contains("main-nav-scrolled")) {
                stickyHead.classList.add("main-nav-scrolled");
            }
        } else {
            if(stickyHead.classList.contains("main-nav-scrolled")){
                stickyHead.classList.remove("main-nav-scrolled");
            }
        }
    };

    loadUserLinks = async () => {
        if (!this.userLinksWrapper) return;

        try {
            const response = await fetch('/Header/UserSpecificLinks', {
                headers: { 'X-Requested-With': 'fetch' }
            });

            const html = response.ok ? await response.text() : '';
            this.userLinksWrapper.innerHTML = html || "";
        } catch (error) {
            console.error("Failed to load user links:", error);
            this.userLinksWrapper.innerHTML = ""; // Clear loading icon
        }
    };

    logClickToCall = async () => {
        const callBtn = document.getElementById("callBtn");
        const phoneNumber = callBtn.getAttribute('data-adobe-v33');
        if (typeof s !== "undefined") {
            s.linkTrackVars = "prop20,eVar20,eVar33,events";
            s.linkTrackEvents = "event28";
            s.events = 'event28';
            s.eVar33 = phoneNumber;
            s.prop20 = 'D=v33';
            s.pe = 'lnk_o';
            s.pev2 = 'Click-to-Call';
            s.tl(true, 'o', 'Click-to-Call');
            s.linkTrackEvents = 'None';
            s.linkTrackVars = 'None';
        }
    };

    // Lazy load seo editor module
    loadSEOEditor = async () => {
        if (!this.seoPromise) {
            this.seoPromise = import('./seoeditor.js')
                .then(({ default: seoEditor }) => seoEditor )
                .catch((error) => {
                    console.error("Failed to load seo editor module:", error);
                    this.seoPromise = null; // Reset to allow retry
                    return null;
                });
        }
        return this.seoPromise;
    }

    // Lazy load cart dropdown module
    loadCartDropdown = async () => {
        if (!this.cartPromise) {
            this.cartPromise = import('./cartdropdown.js')
                .then(({ default: HeaderCartDropdown }) => HeaderCartDropdown )
                .catch((error) => {
                    console.error("Failed to load cart dropdown module:", error);
                    this.cartPromise = null; // Reset to allow retry
                    return null;
                });
        }
        return this.cartPromise;
    }

    // Lazy load account dropdown module
    loadAccountDropdown = async () => {
        if (!this.accountPromise) {
            this.accountPromise = import('./accountdropdown.js')
                .then(({ default: HeaderAccountDropdown }) => HeaderAccountDropdown )
                .catch((error) => {
                    console.error("Failed to load account dropdown module:", error);
                    this.accountPromise = null; // Reset to allow retry
                    return null;
                });
        }
        return this.accountPromise;
    }

    // Lazy load menu module
    loadMenu = async () => {
        if (!this.menuPromise) {
            this.menuPromise = import('./megamenu.js')
                .then(({ default: MegaMenu }) => MegaMenu )
                .catch((error) => {
                    console.error("Failed to load menu module:", error);
                    this.menuPromise = null; // Reset to allow retry
                    return null;
                });
        }
        return this.menuPromise;
    }

    // Lazy load search module
    loadSearch = async () => {
        if (!this.searchPromise) {
            this.searchPromise = import('./search.js')
                .then(({ default: Search4i }) => {
                    Search4i.init();
                    return Search4i;
                })
                .catch((error) => {
                    console.error("Failed to load search module:", error);
                    this.searchPromise = null; // Reset to allow retry
                    return null;
                });
        }
        return this.searchPromise;
    }
}

export default new Header4i();